<template>
  <div style="position: relative;width: 100%;height: 100%;"
       v-loading="loading">
    <img ref="image"
         :src="url"
         :alt="url"
         style="max-width: 100%;max-height:100%;"/>
    <div class="cropper-button">
      <span @click="move()"
            class="el-icon-rank"></span>
      <span @click="crop()"
            class="sj-icon-crop"></span>
      <span @click="cropper.rotate(90)"
            class="sj-icon-rotate-left"></span>
      <span @click="cropper.rotate(-90)"
            class="sj-icon-rotate-right"></span>
      <span @click="cropper.reset()"
            class="el-icon-refresh"></span>
    </div>
  </div>
</template>
<script>
import 'cropperjs/dist/cropper.css'
import Cropper from 'cropperjs'

export default {
  name: 'CropperImage',
  props: {
    url: String,
  },
  data () {
    return {
      isCrop: false,
      loading: false
    }
  },
  watch: {
    url (value) {
      if (value) {
        this.destroy()
        this.create()
      }
    }
  },
  created () {
    this.create()
  },
  mounted () {},
  updated () {},
  destroyed () {
    this.destroy()
  },
  methods: {
    create () {
      this.loading = true
      this.$nextTick(() => {
        this.cropper = new Cropper(this.$refs.image, {
          autoCrop: false,
          dragMode: 'move',
          crop: function (e) {
            // console.log(e.detail.x)
            // console.log(e.detail.y)
            // console.log(e.detail.width)
            // console.log(e.detail.height)
            // console.log(e.detail.rotate)
            // console.log(e.detail.scaleX)
            // console.log(e.detail.scaleY)
          },
        })
        this.$refs.image.addEventListener('ready', () => {
          this.loading = false
        })
      })
    },
    destroy () {
      this.cropper && this.cropper.destroy()
      Object.assign(this.$data, this.$options.data.call(this))
    },
    move () {
      this.isCrop = false
      this.cropper.clear().setDragMode('move')
    },
    crop () {
      if (this.isCrop) {
        this.cropper.clear()
        this.isCrop = false
      } else {
        this.cropper.crop()
        this.isCrop = true
      }
    },
    toDataURL () {
      return this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
    },
    toBlob () {
      return new Promise((resolve, reject) => {
        let canvas = this.cropper.getCroppedCanvas()
        canvas.toBlob((blob) => {
          resolve(blob)
        }, 'image/jpeg')
      })
    },
  },

}
</script>
<style lang="scss"
       scoped>
.cropper-button {
  width: 100%;
  text-align: center;
  background-color: rgba($color: #000000, $alpha: 0.7);
  position: absolute;
  bottom: 0px;
  left: 0px;

  span {
    font-size: 20px;
    color: white;
    padding: 10px;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/CropperImage/src/CropperImage.vue